import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";
import {BaseApiModel} from "../../../infrastructure/models/base-api-model";

export class CommentsFactory extends BaseFactory {

  static injectables = [...BaseFactory.injectables];

  createResponse(apiModel: BaseApiResponseModel) {
    return null;
  }

  createDomainModel(apiModel: BaseApiModel) {
    return null;
  }
}

